import type { LenisOptions } from 'lenis';

/**
 * Lenis, the page's scroll smoothing.
 *
 * `lerp` rather than `duration`: lerp mode reacts continuously to input,
 * whereas duration mode retargets on every wheel event and can feel like
 * it is fighting a fast scroller. Lower is heavier.
 *
 * Touch is already inertial, so it stays native: smoothing it again only
 * adds lag under the finger.
 */
export const LENIS_OPTIONS: Readonly<LenisOptions> = {
  autoRaf: false,
  lerp: 0.09,
  smoothWheel: true,
  syncTouch: false,
};
